import { useContext } from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom'
import ManagersContext from '../../containers/ManagersContext'
import funride from '../../lib/funride/funride.module.less'
import { iLinkObj2} from '../../managers/interfaces'
const urlmap:{[index: string]:string} = {
  angular: 'https://docs.google.com/document/d/e/2PACX-1vTfZ-Xbi3eOBFf7nNVVF_1MystUchd4l9CfT_PJpKV_swIBemjnRedTUiJP1r9CxcUK8VxDYGR8UdXt/pub?embedded=true',
  bootstrap: 'https://docs.google.com/document/d/e/2PACX-1vRzyvQx7cvvaAczNLUCcKUCF8mo9hXAghFaNFnHfwEkWwYdbDgkWCKM4NIRMYyO1bATFnXbS1BFAxRO/pub?embedded=true',
  css: 'https://docs.google.com/document/d/e/2PACX-1vQOwFf8RgvxMCkilGt2iD_hJfR2bJsaTs4U-Z5Hvp4hAAUJA80t-CiClgKlknL-mU3g5fSTLW-3Z0Ej/pub?embedded=true',
  CuRL: 'https://docs.google.com/document/d/e/2PACX-1vTuWhXWlZRStAdAy1s-Md-ATWTA4pt_Fd7oXMlcGp3xtFzSiBN_-30pj66T0yHfHG9qpB6oek5N8SKp/pub?embedded=true',
  flexbox: 'https://docs.google.com/document/d/e/2PACX-1vT3kxRj1UdxTiAZjREbrKBR3dHUDKWXkBETK94xgjrp6dJFzRa4tBcrRtLRPaIbuPyKp7YB_9t2d9lt/pub?embedded=true',
  git: 'https://docs.google.com/document/d/e/2PACX-1vRV7hpdyz2uetPryrNkDi10OvByOoeZnM2hOYGsoMT8FzpimTiuRTgcTeqWoR5hnzeXSZvjXz8lvp2e/pub?embedded=true',
  html: 'https://docs.google.com/document/d/e/2PACX-1vRsngjNo1aET2ngaCylUC7IXtd7owYbo1HIi_TuAEnNV4TW4lRRUIi5kR-oO9KuHjax5mOAjU4OuZOE/pub?embedded=true',
  javascript: 'https://docs.google.com/document/d/e/2PACX-1vTuHQJlLei5GLQgeuyHh_br0kWr6qpG3UWzJ6Lu3KS3lcSUSmU_02YBB08uLxxiU-MEqLGbzoqD_Vd8/pub?embedded=true',
  'javascript-hoisting': 'https://docs.google.com/document/d/e/2PACX-1vQiB1SvxGnps-r21oHjW3PJuOSrd_0xC9ze-kkoyWSSlhv--HBjP5Sj0KGSmChitBZOLeGUAxKi6pSF/pub?embedded=true',
  'javascript-promises': 'https://docs.google.com/document/d/e/2PACX-1vT8-h-85fbg6ytrwawYItmCtR1Yd2ntK3eDrlzJVomVB_JBbXzY6p7TivSaM-yBBQYXFDN4xiJogD4a/pub?embedded=true',
  node: 'https://docs.google.com/document/d/e/2PACX-1vR1P0CMeuzcBiA3dLBtDZluGvtJpzCNeVDLtaZhI0PPEQT9N7l8-pA6y-sU5SaiEfnGA0qct4-uerU7/pub?embedded=true',
  'performance-tuning': 'https://docs.google.com/document/d/e/2PACX-1vQ0ao3yCNBBrrZ4L3b4a9zBFofsLuFf74y1WMlDnqmN3c1IV1FzQARffu6OUFZoRHrW4YTn9NAPTtjf/pub?embedded=true',
  react: 'https://docs.google.com/document/d/e/2PACX-1vT4UZ-u8fVREFNFvimR7fc9IXNyABCypMhdy5pLnyUQQsc6-SVibc0X7Qa8oTh9RkLq3gyrwXbBraDn/pub?embedded=true',
  'react-hooks': 'https://docs.google.com/document/d/e/2PACX-1vQH1l8m1tLTQbyb3tDM9eWYyx-4PMQuPhao_RkqrAUWmLh7bmQN0Ne7X7pkdUP8liVWXoXfdJuK9vmf/pub?embedded=true',
  redux: 'https://docs.google.com/document/d/e/2PACX-1vReLvAzR6QhHKsQ1UGSOUdP3ZoxGyPqNSis5N9CPyWHClspgDRv5CMtKl9YGl58rxN-jytR_p7L2Adn/pub?embedded=true',
  'responsive-design': 'https://docs.google.com/document/d/e/2PACX-1vSP2iUM77NTfgr1XOH-e8ZgH8fzHTugMN-3PC_MiX9gFuq5HLZPnT785MwIizKS2k9RqarzqhkPiGvc/pub?embedded=true',
  sequelize: 'https://docs.google.com/document/d/e/2PACX-1vSKfIcniImee-vPMZViIUObvqZK1YrgP8_8q_AQRsUMpu0d26gGOfDtf8pzulkEkdpswIORz1K8HF3b/pub?embedded=true',
  'software-engineering': 'https://docs.google.com/document/d/e/2PACX-1vSyqGErVkS5Vvkn23g2nRPJHzK41YuNJvV8nfNbgnQEztOShC9rYoJjX-BRgFBIICiGyHv_FA1JoVz4/pub?embedded=true',
  sql: 'https://docs.google.com/document/d/e/2PACX-1vRc1N49BBy9LXvJbrzbR1Dk54a-fh_9ae3dJYmrVuIWdQ9l645rE25ne11LqDPMZUv6DE6OC2TPOKlR/pub?embedded=true',
  webpack: 'https://docs.google.com/document/d/e/2PACX-1vQeVuT3MkiZJfDgH6MdtetGpw9SLgZF8a928urGg29k1UM0bNZenVIavugT7ThN1f_WMh3yFOUDWfnE/pub?embedded=true'
}
interface iInnerPageTech {
  topic: string
}
export default function InnerPageTech (props: iInnerPageTech) {
  if (props.topic === 'list') {
    return <ListTopic />
  } else {
    return (
      <div>
        <header>
          <h1>Programming: <span className={funride.techTitle}>{props.topic}</span></h1>
          <p>Quick answers on the topic of <span className={funride.techTitle}>{props.topic}</span>.</p>
        </header>
        <iframe
          id={funride.tech}
          src={urlmap[props.topic]}
        />
      </div>

    )
  }
}
const ListTopic = () => {
  const {sidebarPageManager} = useContext(ManagersContext)
  return (
    <div>
      <header>
        <h1>Programming Technologies</h1>
        <p>
          These are some of the technologies I support.
          Each topic links to quick answers on the technology.
        </p>
      </header>
      {/*TODO Move this style into funride */}
      <ul className={funride.singleLines}> {
        sidebarPageManager.techList.map((tech:iLinkObj2, i:number) => (
          <li style={{fontSize: '1.2em'}} key={`tech_${i}`}><Link to={tech.url}>{tech.text}</Link></li>
        ))
      }
      </ul>
    </div>
  )
}
InnerPageTech.propTypes = {
  topic: PropTypes.string
}
InnerPageTech.defaultProps = {
  topic: 'list'
}
